"use client";
import { NavBar, type NavBar_T } from "@areahub/ui/marketing/nav-bar/nav-bar";

export interface EnterpriseOrIndividualsNavBarProps {
  enterpriseNav: NavBar_T;
}

export default function GlobalNavBar({
  enterpriseNav,
}: EnterpriseOrIndividualsNavBarProps) {
  if (enterpriseNav) {
    return (
      <NavBar
        navigation={enterpriseNav.navigation}
        banner={enterpriseNav.banner}
      />
    );
  }
  return <></>;
}
